import React, { useState, useEffect, useRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import './UserProfileDropdown.css';

interface UserProfileDropdownProps {
    onNavigateToMint: () => void;
}

const UserProfileDropdown: FC<UserProfileDropdownProps> = ({
    onNavigateToMint
}) => {
    const { t } = useTranslation();
    const { user, logout, isAuthenticated } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (!isAuthenticated || !user) return null;

    const handleLogout = async () => {
        await logout();
        setIsOpen(false);
    };

    return (
        <div className="user-profile-dropdown" ref={dropdownRef}>
            <button onClick={toggleDropdown} className="profile-icon-button">
                {user.picture ? (
                    <img src={user.picture} alt={user.name} className="profile-avatar" />
                ) : (
                    <span className="profile-initial">{user.name?.charAt(0)?.toUpperCase() || user.email?.charAt(0)?.toUpperCase() || '?'}</span>
                )}
            </button>
            {isOpen && (
                <div className="dropdown-menu">
                    <div className="dropdown-header">
                        {user.picture ? (
                            <img src={user.picture} alt={user.name} className="dropdown-avatar" />
                        ) : (
                            <div className="dropdown-avatar-placeholder">
                                {user.name?.charAt(0)?.toUpperCase() || user.email?.charAt(0)?.toUpperCase() || '?'}
                            </div>
                        )}
                        <div className="dropdown-user-info">
                            <strong>{user.name}</strong>
                            <span>{user.email}</span>
                        </div>
                    </div>
                    <hr />
                    <button
                        onClick={() => { onNavigateToMint(); setIsOpen(false); }}
                        className="dropdown-item-button"
                    >
                        {t('issueNewCertificate') || 'Issue New Certificate'}
                    </button>
                    <button
                        onClick={handleLogout}
                        className="dropdown-item-button disconnect-button"
                    >
                        {t('auth.signOut')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserProfileDropdown;
